import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const get = (params) =>
  requestsTemplates.get(mainPath, "/notifications",params);
